import React from 'react';

const FAQs = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">FAQs for Xgo Life App</h1>
      <p className="mb-4">
        These FAQs aim to address common concerns and enhance user experience with the Xgo Life App. For any additional questions, feel free to reach out to customer support.
      </p>

      <h2 className="text-2xl font-semibold mt-6">1. What is the Xgo Life App?</h2>
      <p className="mb-4">The Xgo Life App is a platform that allows users to shop online, schedule deliveries, and access various services conveniently from their mobile devices.</p>

      <h2 className="text-2xl font-semibold">2. How do I create an account?</h2>
      <p className="mb-4">Download the app, click on "Sign Up," and provide your email address, create a password, and enter any required personal information. Follow the prompts to complete the registration process.</p>

      <h2 className="text-2xl font-semibold">3. What should I do if I forget my password?</h2>
      <p className="mb-4">Click on the "Forgot Password?" link on the login page. Follow the instructions to reset your password via your registered email.</p>

      <h2 className="text-2xl font-semibold">4. How can I browse products?</h2>
      <p className="mb-4">Use the app’s search bar to find specific items or explore different product categories available on the home page.</p>

      <h2 className="text-2xl font-semibold">5. What payment methods are accepted?</h2>
      <p className="mb-4">The app accepts various payment methods, including credit/debit cards, digital wallets, and other secure payment options. Check the app for specific methods available in your region.</p>

      <h2 className="text-2xl font-semibold">6. Can I track my order?</h2>
      <p className="mb-4">Yes, you can track your order status through the app. Notifications will also be sent to keep you updated on the progress of your delivery.</p>

      <h2 className="text-2xl font-semibold">7. What should I do if my order is damaged or incorrect?</h2>
      <p className="mb-4">Contact customer support immediately through the app to report any issues with your order. Provide your order number and details of the issue for assistance.</p>

      <h2 className="text-2xl font-semibold">8. What is the return policy?</h2>
      <p className="mb-4">The return policy allows returns within a specified period (usually 30 days) for items that are unused and in original packaging. Check the app for detailed return instructions.</p>

      <h2 className="text-2xl font-semibold">9. How can I contact customer support?</h2>
      <p className="mb-4">You can reach customer support through the "Help" or "Contact Us" section in the app. Options may include live chat, email, or a phone number.</p>

      <h2 className="text-2xl font-semibold">10. Are there any shipping fees?</h2>
      <p className="mb-4">Shipping fees may apply depending on the order total and delivery location. The app will display any applicable shipping costs during the checkout process.</p>

      <h2 className="text-2xl font-semibold">11. Can I change or cancel my order after placing it?</h2>
      <p className="mb-4">Orders can typically be modified or canceled within a short period after placement. Check the app for specific guidelines on changing or canceling orders.</p>

      <h2 className="text-2xl font-semibold">12. Is my personal information secure?</h2>
      <p className="mb-4">Yes, the Xgo Life App employs industry-standard security measures to protect your personal and payment information. Refer to our Privacy Policy for more details.</p>

      <h2 className="text-2xl font-semibold">13. How can I provide feedback?</h2>
      <p className="mb-4">You can provide feedback through the app’s feedback feature or by contacting customer support. We value your input and strive for continuous improvement.</p>

      <h2 className="text-2xl font-semibold">14. What if I encounter technical issues with the app?</h2>
      <p className="mb-4">If you experience any technical issues, please report them to customer support through the app so that they can assist you promptly.</p>
    </div>
  );
};

export default FAQs;